/* eslint-disable react/jsx-props-no-spreading */
import { Controller } from "react-hook-form";
import Select from "react-select";
import "./FormSelect.css";
import { FormSelectProps } from "./types";

function FormSelect({
  label,
  subLabel, // optional
  bottomLabel, // optional
  control,
  name,
  placeholder, // optional
  options,
  formState,
  rules,
  disabled,
  multi,
  defaultValue,
}: FormSelectProps) {
  return (
    <div className="FormSelect FormInput">
      <label className="text-base font-medium" htmlFor={name}>
        {label}
      </label>
      {subLabel && <p className="subLabel">{subLabel}</p>}
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ field: { onChange, onBlur, value } }) => (
          <Select
            options={options}
            onChange={onChange}
            value={value}
            onBlur={onBlur}
            placeholder={placeholder}
            isDisabled={disabled}
            isMulti={multi}
            defaultInputValue={defaultValue}
          />
        )}
      />
      {bottomLabel && <p className="bottom-label">{bottomLabel}</p>}
      {formState.errors[name] && (
        <p className="text-red-500">
          {formState.errors[name]?.message?.toString()}
        </p>
      )}
    </div>
  );
}

export default FormSelect;
